import actions from "./actions";

const initState = {
  loading: false,
  error: null,
  totalBillersData: {},        
  searchBillersResult: null, 
  categories: [],  
};

export default function BillerReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_TOTAL_BILLERS:
       return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.SEARCH_BILLERS:
  
      return {
        ...state,
        loading: false,
        error: null,
      };

          case actions.GET_CATEGORIES:
              return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.GET_TOTAL_BILLERS_SUCCESS:
      return {
        ...state,
        loading: false,
        totalBillersData: action.payload.data || {},
      };

      
    case actions.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload.data || [],
      };

    case actions.SEARCH_BILLERS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchBillersResult: action.payload.data || null,
      };

    case actions.GET_TOTAL_BILLERS_FAILED:
    case actions.SEARCH_BILLERS_FAILED:
      case actions.GET_CATEGORIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case actions.CLEAR_SEARCH_BILLERS:
      return {
        ...state,
        searchBillersResult: null,
      };

    default:
      return state;
  }
}
